var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatH2I = function SvgChatH2I(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M14.118 16a.356.356 0 0 1-.352-.35 2.27 2.27 0 0 1 1.209-1.738c.538-.4.867-.676.867-1.053a.54.54 0 0 0-.6-.525.583.583 0 0 0-.6.594.353.353 0 0 1-.352.354.354.354 0 0 1-.355-.354 1.44 1.44 0 0 1 .307-.857 1.26 1.26 0 0 1 1-.445 1.25 1.25 0 0 1 1.315 1.234c0 .775-.644 1.244-1.16 1.619a3 3 0 0 0-.832.813h1.727a.36.36 0 0 1 .356.359.36.36 0 0 1-.356.35zm-2.742-.412v-3.166H8.35v3.156a.42.42 0 0 1-.422.422.414.414 0 0 1-.427-.412V8.422A.42.42 0 0 1 7.928 8a.416.416 0 0 1 .411.422v3.166h3.026V8.422A.426.426 0 0 1 11.787 8a.426.426 0 0 1 .427.422v7.156a.42.42 0 0 1-.427.422.41.41 0 0 1-.411-.412"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatH2I);
export default ForwardRef;